module.exports = __webpack_public_path__ + "img/720x900-soru-3.44217dc4.jpg";